import { render } from "./DisplaySettings.vue?vue&type=template&id=ca081330&scoped=true"
import script from "./DisplaySettings.vue?vue&type=script&lang=js"
export * from "./DisplaySettings.vue?vue&type=script&lang=js"

import "./DisplaySettings.vue?vue&type=style&index=0&id=ca081330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca081330"]])

export default __exports__